import { Sheet } from '@repo/videa-components/src/index';

import type { Appointment } from '../../../../../react-query/useAppointments';
import type { GetTaskResponse } from '../../../../../react-query/useGetTasks';
import { type TVisitSummary } from '../../../../../react-query/useVisitSummaries';

import { PatientInfoSheetContent } from './PatientInfoSheetContent';

interface PatientInfoSheetProps {
  appointment: Appointment;
  index: number;
  visitSummaries?: TVisitSummary[];
  patientTask?: GetTaskResponse;
  onClickPreviousAppt: (selectedAppointment: {
    unifiedId: string;
    estimatedVisitId: number | undefined;
  }) => void;
  onClickNextAppt: (selectedAppointment: {
    unifiedId: string;
    estimatedVisitId: number | undefined;
  }) => void;
  selectedAppointment?: {
    unifiedId: string;
    estimatedVisitId?: number;
  };
  hideProviderAvatar?: boolean;
  children?: React.ReactNode;
}

const PatientInfoSheet: React.FC<PatientInfoSheetProps> = ({
  children,
  appointment,
  index,
  visitSummaries,
  patientTask,
  selectedAppointment,
  hideProviderAvatar = false,
  onClickPreviousAppt,
  onClickNextAppt,
}) => {
  const visitSummary = visitSummaries?.find((summary?: TVisitSummary) => {
    if (
      summary?.unifiedAppointmentId && selectedAppointment?.unifiedId
        ? summary.unifiedAppointmentId ===
          parseInt(selectedAppointment.unifiedId)
        : summary?.estimatedVisitId &&
          summary.estimatedVisitId === selectedAppointment?.estimatedVisitId
    ) {
      return summary;
    }
  });

  return (
    <Sheet>
      {children}
      <PatientInfoSheetContent
        appointment={appointment}
        index={index}
        visitSummary={visitSummary}
        patientTask={patientTask}
        selectedAppointment={selectedAppointment}
        hideProviderAvatar={hideProviderAvatar}
        onClickPreviousAppt={onClickPreviousAppt}
        onClickNextAppt={onClickNextAppt}
      />
    </Sheet>
  );
};

export default PatientInfoSheet;
